import { Navigate } from 'react-router-dom';

/**
 * ProtectedRoute Component
 * 
 * Validates JWT token before rendering protected routes.
 * Redirects to /login if no valid token exists.
 * 
 * Usage:
 * <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
 */
function ProtectedRoute({ children }) {
  const token = localStorage.getItem('spes_token');

  // If no token, redirect to login
  if (!token) {
    console.log('❌ No token found - redirecting to login');
    return <Navigate to="/login" replace />;
  }

  // Token exists, render protected content
  return children;
}

export default ProtectedRoute;
